import { useState } from 'react';
import { Input } from '@components/Input';
import { IconSearch, IconFilter } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const InputsSection = () => {
  const [inputValue, setInputValue] = useState('');

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Inputs"
        description="Input fields for user data entry with various states and features."
        figmaNodeId="5-44"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Basic Input</h3>
        <div className={styles.inputRow}>
          <Input value={inputValue} onChange={setInputValue} placeholder="Enter text..." />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Leading Icon</h3>
        <div className={styles.inputRow}>
          <Input
            value={inputValue}
            onChange={setInputValue}
            placeholder="Search..."
            leadingIcon={<IconSearch size={18} />}
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Clearable</h3>
        <div className={styles.inputRow}>
          <Input
            value={inputValue}
            onChange={setInputValue}
            placeholder="Type something..."
            clearable
            onClear={() => setInputValue('')}
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Filter Input</h3>
        <div className={styles.inputRow}>
          <Input
            value={inputValue}
            onChange={setInputValue}
            placeholder="Filter"
            leadingIcon={<IconFilter size={18} />}
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Slim Variant</h3>
        <div className={styles.inputRow}>
          <Input
            value={inputValue}
            onChange={setInputValue}
            placeholder="Filter..."
            leadingIcon={<IconSearch size={14} />}
            clearable
            size="slim"
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Slim with Leading Icon</h3>
        <div className={styles.inputRow}>
          <Input
            value={inputValue}
            onChange={setInputValue}
            placeholder="Search..."
            leadingIcon={<IconFilter size={14} />}
            size="slim"
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Slim Disabled</h3>
        <div className={styles.inputRow}>
          <Input value="Disabled slim" placeholder="Disabled" disabled size="slim" />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Disabled</h3>
        <div className={styles.inputRow}>
          <Input value="Disabled input" placeholder="Disabled" disabled />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Error State</h3>
        <div className={styles.inputRow}>
          <Input
            value="https://duplicate-site.com"
            placeholder="Enter URL..."
            leadingIcon={<IconSearch size={18} />}
            error="A lead with this domain already exists"
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Clearable with Error</h3>
        <div className={styles.inputRow}>
          <Input
            value={inputValue}
            onChange={setInputValue}
            placeholder="Type something..."
            clearable
            onClear={() => setInputValue('')}
            error={inputValue.length > 0 ? 'This value is invalid' : undefined}
          />
        </div>
      </div>
    </section>
  );
};
